import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  GetMarketingContactsParams,
  GetMarketingContactsResponse
} from "../../marketing.types";
import { requestGetMarketingContacts } from "./getMarketingContacts.request";

const useMarketingContacts = (
  params: GetMarketingContactsParams,
  options?: QueryOptions<
    GetMarketingContactsResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["marketing", "contacts", "list", params],
    queryFn: async () => await requestGetMarketingContacts(params),
    onError: toastServerError,
    keepPreviousData: true,
    ...options
  });

  return { contacts: data?.items ?? [], total: data?.total ?? 0, ...rest };
};

export default useMarketingContacts;
